import React from "react";
import { Helmet } from "react-helmet";
import SiteBreadcrumb from "../../../components/Common/Breadcumb";
import OffWrap from "../../../components/Layout/Header/OffWrap";
import Footer from "../../../components/Layout/Footer/FooterStyleOne";
import SearchModal from "../../../components/Layout/Header/SearchModal";
import ScrollToTop from "../../../components/Common/ScrollTop";
import Newsletter from "../../../components/Common/Newsletter";
import Header from "../../../components/Layout/Header/Header";
import ServiceCard from "../../../components/Service/ServiceCard";
import { Link } from "react-router-dom";

import { FaBug, FaCheckCircle, FaRobot, FaCode, FaShieldAlt, FaMobileAlt, FaChartLine, FaCogs } from "react-icons/fa";

import bannerbg from "../../../assets/img/breadcrumbs/sssss.jpg";
import Logo from "../../../assets/img/logo/dark-logo.png";
import footerLogo from "../../../assets/img/logo/lite-logo.png";
import favIcon from "../../../assets/img/fav.png";
import IndustriesSection from "../../home/IndustriesSection";

const serviceCards = [
    {
        icon: <FaRobot size={80} color="var(--brand-primary)" />,
        title: "Automated Testing",
        description: "Comprehensive test automation including unit, integration, and end-to-end tests. We build test suites that run automatically on every code change, catching bugs before they reach production.",
    },
    {
        icon: <FaBug size={80} color="var(--brand-primary)" />,
        title: "Manual Testing & QA",
        description: "Thorough manual testing by experienced QA engineers to catch edge cases and usability issues. We test across devices, browsers, and scenarios to ensure quality.",
    },
    {
        icon: <FaCode size={80} color="var(--brand-primary)" />,
        title: "Code Reviews & Quality Gates",
        description: "Peer code reviews and automated quality gates to maintain code standards. We enforce best practices, catch potential issues, and ensure maintainable code.",
    },
    {
        icon: <FaMobileAlt size={80} color="var(--brand-primary)" />,
        title: "Cross-Platform Testing",
        description: "Test your applications across multiple devices, browsers, and operating systems. We ensure consistent behavior and appearance everywhere your users access your product.",
    },
    {
        icon: <FaShieldAlt size={80} color="var(--brand-primary)" />,
        title: "Security Testing",
        description: "Identify vulnerabilities through security testing and penetration testing. We test for common security flaws and ensure your application is protected against threats.",
    },
    {
        icon: <FaChartLine size={80} color="var(--brand-primary)" />,
        title: "Performance Testing",
        description: "Load testing, stress testing, and performance benchmarking to ensure your application handles expected traffic. We identify bottlenecks before they impact users.",
    },
    {
        icon: <FaCogs size={80} color="var(--brand-primary)" />,
        title: "Continuous Integration Testing",
        description: "Integrate testing into your CI/CD pipeline for continuous quality assurance. We ensure every code change is tested automatically before deployment.",
    },
    {
        icon: <FaCheckCircle size={80} color="var(--brand-primary)" />,
        title: "Acceptance Testing & UAT",
        description: "Validate that your software meets business requirements through acceptance testing. We work with stakeholders to ensure the product delivers expected value.",
    },
];

const QualityAssuranceTesting = () => {
    return (
        <React.Fragment>
            <Helmet>
                <link rel="icon" href={favIcon} />
                <title>Quality Assurance & Testing - Syrol Tech</title>
                <meta name="description" content="Continuous testing, code reviews, and quality controls embedded throughout the development lifecycle to ensure stable, production-ready software." />
            </Helmet>
            <OffWrap />
            <Header
                parentMenu="pages"
                secondParentMenu="others"
                headerNormalLogo={Logo}
                headerStickyLogo={Logo}
                CanvasLogo={Logo}
                mobileNormalLogo={Logo}
                CanvasClass="right_menu_togle hidden-md"
                headerClass="full-width-header header-style1 home8-style4"
                TopBar="enable"
                TopBarClass="topbar-area home8-topbar"
                emailAddress="hello@syroltech.com"
                Location="Abuja, Nigeria"
            />
            <SiteBreadcrumb
                pageTitle="Quality Assurance & Testing"
                pageName="Quality Assurance & Testing"
                breadcrumbsImg={bannerbg}
            />
            <section className="consultation-hero-section position-relative w-100" style={{ minHeight: '420px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: `url(${bannerbg}) center/cover no-repeat` }}>
                <div className="hero-overlay" style={{ position: 'absolute', inset: 0, background: 'rgba(10, 18, 32, 0.72)', zIndex: 1 }}></div>
                <div className="container position-relative" style={{ zIndex: 2, maxWidth: '900px', padding: '3rem 1rem', textAlign: 'left' }}>
                    <h1 style={{ color: '#fff', fontWeight: 700, fontSize: '2.6rem', lineHeight: 1.15, marginBottom: '1.2rem' }}>Deliver stable, production-ready software</h1>
                    <p style={{ color: '#fff', fontSize: '1.25rem', maxWidth: '600px', marginBottom: '2.2rem' }}>Continuous testing, code reviews, and quality controls embedded throughout the development lifecycle to ensure stable, production-ready software.</p>
                    <Link to="/consultation" className="readon orange-btn" style={{ padding: '12px 28px', fontSize: '1rem', borderRadius: '6px', fontWeight: 700, textDecoration: 'none', display: 'inline-block', transition: 'background 0.2s' }}>Request A Free Proposal</Link>
                </div>
            </section>
            <div className="rs-contact style1 event-bg pt-110 md-pt-10 pb-100 md-pb-80">
                <div className="container pb-66 md-pb-46">
                    <h2 className="service-title mb-32">Our Quality Assurance & Testing Services</h2>
                    {serviceCards.map((card, idx) => (
                        <ServiceCard
                            key={idx}
                            icon={card.icon}
                            title={card.title}
                            description={card.description}
                        />
                    ))}
                </div>
            </div>
            <IndustriesSection />
            <Newsletter
                sectionClass="rs-newsletter style1 orange-color event-bg mb--90 sm-mb-0 sm-pb-80"
                titleClass="title mb-0 white-color"
            />
            <Footer
                footerClass="rs-footer home9-style main-home"
                footerLogo={footerLogo}
            />
            <SearchModal />
            <ScrollToTop scrollClassName="scrollup orange-color" />
        </React.Fragment>
    );
};

export default QualityAssuranceTesting;
